import { render, staticRenderFns } from "./gTitle.vue?vue&type=template&id=db5f376c&scoped=true&"
import script from "./gTitle.vue?vue&type=script&lang=js&"
export * from "./gTitle.vue?vue&type=script&lang=js&"
import style0 from "./gTitle.vue?vue&type=style&index=0&id=db5f376c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f376c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db5f376c')) {
      api.createRecord('db5f376c', component.options)
    } else {
      api.reload('db5f376c', component.options)
    }
    module.hot.accept("./gTitle.vue?vue&type=template&id=db5f376c&scoped=true&", function () {
      api.rerender('db5f376c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zzy/components/gTitle.vue"
export default component.exports